import React from 'react';

import { DataTableProps } from '../DataTable/DataTable';
import { Indexable } from 'src/interfaces/interfaces';
import NestedTableRow from './NestedTableRow';

import './NestedTable.scss';

interface NestedTableProps extends DataTableProps {
    innerTables: Array<React.ReactElement>;
}

export default function NestedTable({ data, innerTables, keys, labels }: NestedTableProps) {
    if (labels.length !== keys.length) {
        console.error('NestedTable: labels and keys must be of equal length');
        return null;
    }

    return (
        <table className="nested-table">
            <thead className="nested-table__head">
                <tr>
                    <th className="nested-table__cell--header">&nbsp;</th>
                    {labels.map((label, i) => (
                        <th key={i} className="nested-table__cell nested-table__cell--header">
                            {label}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody className="nested-table__body">
                {data.map((datum: Indexable, i: number) => (
                    <NestedTableRow key={i} data={datum} keys={keys} innerTable={innerTables[i]} />
                ))}
            </tbody>
        </table>
    );
}

NestedTable.defaultProps = {
    data: [],
    innerTables: [],
    keys: [],
    labels: [],
};
